<template>
    <v-form @submit.prevent="saveFolder" ref="form">
        <v-card class="elevation-1 rounded-4"> 
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">{{ mode }} Folder</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="text-xs-center">
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-text-field label="Name"
                        v-model="folderName"
                        :rules="[rules.required]"
                        maxlength="25"
                        hint="Max 25 alphanumeric characters"
                        :disabled="disabled"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout v-if="isMobile" row wrap>
                    <v-flex xs12 sm12 class="text-xs-left" style="margin-left:8px;">
                        <v-btn icon @click="dialogColorPicker=true">
                            <v-icon :color="color" large>folder</v-icon>
                        </v-btn>
                        Click folder to change color
                    </v-flex> 
                </v-layout>
                <v-layout v-else row wrap>
                    <v-flex xs12 sm2>
                        <v-btn icon @click="dialogColorPicker=true">
                            <v-icon :color="color" large>folder</v-icon>
                        </v-btn>
                    </v-flex> 
                    <v-flex xs12 sm10>
                        <div class="text-xs-left form-folder">Click folder to change color</div>
                    </v-flex> 
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-content">
                        <v-textarea label="Description"
                            v-model="folderDescription"
                            :rules="[rules.required]"
                            maxlength="1000"
                            rows="1"
                            :disabled="disabled"></v-textarea>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="mr-20">
                <v-spacer></v-spacer>
                <v-btn v-if="canDelete" @click="showDeleteFolder" class="error" dark :loading="loading_delete">Delete</v-btn>
                <v-btn type="submit" class="primary" dark :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogColorPicker" persistent width="500">
            <color-picker ref="refColorPicker" :dialogColorPicker.sync="dialogColorPicker" @send="setColor"></color-picker>
        </v-dialog>
        <v-dialog v-model="dialogOkCancel" persistent width="500">
            <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="deleteFolder"></ok-cancel>
        </v-dialog>
    </v-form>
</template>
<script>

import hr201Api from '@/api/hr201'
import { hasDeleteRights } from '@/helpers/access-permissions'

export default {
    components: {
        'color-picker': () => import('@/components/Common/ColorPicker'),
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
    },
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            loading_folderfilecount: false,
            disabled: false,
            rules: {
                required: value => !!value || 'Required.',
            },
            mode: '',
            dialogColorPicker: false,
            dialogOkCancelMsg: '',
            dialogOkCancel: false,
            folderName: null,
            folderDescription: null,
            folderId: null,
            folderFileCount: null,
            color: '#F9A825'
        }
    },
    methods: {
        showDeleteFolder() {
            this.dialogOkCancelMsg = `This action will delete <b>${this.folderName}</b> folder.<br> Do you want to proceed?`
            this.dialogOkCancel = true
        },
        async deleteFolder() {
            try {
                this.dialogOkCancel = false
                this.loading_delete = true
                const response = await hr201Api.deleteFolder(this.folderId)
                if (response && response.status == 200) {
                    this.$emit('send', response.data)
                    this.closeDialog()
                    this.loading_delete = false
                }
               
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        setColor(selectedColor) {
            this.color = selectedColor
        },
        getColor() {
            return this.color ? this.color : 'transparent'
        },
        async saveFolder() {
            try {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    let response;
                    const data = {
                        folderId: this.folderId,
                        folderName: this.folderName,
                        folderDescription: this.folderDescription,
                        color: this.color,
                        icon: '', //future updates
                    }
                    if (this.createMode) {
                        response = await hr201Api.createFolder(data)
                    } else {
                        response = await hr201Api.updateFolder(data)
                    }
                    if (response && response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                        this.loading = false
                    }
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getFolderFileCount() {
            try {
                this.loading_folderfilecount = true
                const response = await hr201Api.getFolderFileCount(this.folderId)
                if (response && response.status == 200) {
                    this.folderFileCount = response.data
                }
                this.loading_folderfilecount = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        setAdd() {
            this.$refs.form.reset()
            this.folderId = null
            this.mode = 'Create'
            this.color = '#F9A825' //default color
        },
        setEdit(data) {
            this.mode = 'Edit'
            this.folderId = data.folderId
            this.folderName = data.folderName
            this.folderDescription = data.folderDescription
            this.color = data.color
            this.folderFileCount = null //reset on every folder edit
            this.getFolderFileCount()
        },
        closeDialog() {
            this.$emit('update:dialogFolder', false)
        },
    },
    created() {},
    computed: {
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        canDelete() {
            return this.hasDeleteRights &&
                !this.createMode && 
                !this.loading_folderfilecount && 
                !this.hasFilesInFolder
        },
        createMode() {
            return this.mode == 'Create'
        },
        hasFilesInFolder() {
            return this.folderFileCount && this.folderFileCount > 0
        }
    },
    
}
</script>
<style scoped>
.color-box {
  width: 100%;
  cursor: pointer;
  border: 1px solid grey;
  padding: 2px;
}
.form-content {
    padding:5px 20px 0px 20px
}
.form-folder {
    margin:14px 0px 0px 10px;
}
</style>